import {
  Box,
  Button,
  Modal,
  SpaceBetween,
  StatusIndicator,
  Table,
} from "@amzn/awsui-components-react";
import { useState } from "react";
import { Tombstone } from "../../types/events";
import { clearModalParam, setModalParam } from "../../helpers/modalUrlUtils";

const MODAL = "tombstones";

export function TombstoneList({ tombstones }: { tombstones: Tombstone[] }) {
  const [visible, setVisible] = useState(
    () => new URLSearchParams(window.location.search).get("modal") === MODAL
  );

  if (!tombstones.length) {
    return <StatusIndicator type="stopped">No Tombstones</StatusIndicator>;
  }

  const close = () => {
    setVisible(false);
    clearModalParam();
  };

  return (
    <>
      <Button
        variant="inline-link"
        onClick={() => {
          setVisible(true);
          setModalParam(MODAL);
        }}
      >
        <StatusIndicator type="info">
          {tombstones.length === 1
            ? "1 Tombstone"
            : `${tombstones.length} Tombstones`}
        </StatusIndicator>
      </Button>
      <Modal
        visible={visible}
        onDismiss={close}
        header="Tombstones"
        size="medium"
      >
        <SpaceBetween size="m">
          <Box>
            CBEs for a tombstoned usecase are not published. A tombstone without
            a usecase covers every usecase.
          </Box>
          <Table
            variant="embedded"
            items={tombstones}
            trackBy={(tombstone) =>
              `${tombstone.tombstoneId}#${tombstone.usecase ?? ""}`
            }
            columnDefinitions={[
              {
                id: "tombstoneId",
                header: "Tombstone ID",
                cell: (tombstone) => tombstone.tombstoneId,
              },
              {
                id: "usecase",
                header: "Usecase",
                cell: (tombstone) => tombstone.usecase ?? "All usecases",
              },
            ]}
          />
        </SpaceBetween>
      </Modal>
    </>
  );
}
